<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="496")
  yz-card
    yz-dialog-normal-header(title="Select document type" @close="onCloseDialog")
    yz-dialog-normal-content.px-8.py-8
      .yz-medium-body-sm.neutral700--text Choose a document to create and proceed.
      yz-card.mt-5(outlined)
        .pa-4
          .yz-heading-9.neutral700--text {{ title }}
          .yz-regular-body-sm.neutral500--text.mt-1 {{ description }}
          yz-radio-group.mt-4(v-model="selectedOption" :spacing="12")
            yz-radio(v-for="opt in options" :key="opt.value" :value="opt.value" :label="opt.label" label-class="yz-medium-body-sm")
    yz-dialog-normal-actions(save-label="Confirm" :disable-save="!selectedOption" @save="onConfirm" @cancel="onCloseDialog")
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    options: { type: Array, default: () => [] }
  },
  data() {
    return {
      selectedOption: null
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm', this.selectedOption)
      this.showDialog = false
      this.selectedOption = null
    },
    onCloseDialog() {
      this.showDialog = false
      this.selectedOption = null
    }
  }
}
</script>
